import { IonButton, IonIcon, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { sendNotifications } from "../../../store/MassNotification/actions/sendNotifications";
import { sendOutline } from "ionicons/icons";

const textStyle = {
  paddingLeft: 5,
};

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const state = useSelector((state: RootState) => state.massNotification);

  const onSubmit = async () => {
    dispatch(sendNotifications());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        disabled={
          state.totalPeople === 0 ||
          (!state.email && !state.whatsapp) ||
          state.sendNotificationStatus === "pending"
        }
        onClick={() => {
          present({
            header: `¿Deseas enviar notificaciones a ${state.totalPeople} ${
              state.totalPeople === 1 ? "persona" : "personas"
            }?`,
            buttons: [
              "No",
              {
                text: `Enviar notificaciones`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Enviar{" "}
        <span style={textStyle} className="ion-hide-md-down">
          notificaciones
        </span>
        <IonIcon icon={sendOutline} style={textStyle} className="ion-hide-md-up" />
      </IonButton>
    </>
  );
};
